// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */
import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model'

export interface CreateWorkshopNoteRequestPayload {
  id: number; // course id
  vodId: number;
  time: number;
  message: string;
}

export interface CreateWorkshopNoteSuccessPayload {
  id: number;
  notes: Note[];
}

export interface CreateWorkshopNoteFailPayload {
  error: Error;
}

const createWorkshopNoteActions = createAsyncAction(
  'elearning/CREATE_WORKSHOP_NOTE_REQUEST',
  'elearning/CREATE_WORKSHOP_NOTE_SUCCESS',
  'elearning/CREATE_WORKSHOP_NOTE_FAIL'
)<CreateWorkshopNoteRequestPayload, CreateWorkshopNoteSuccessPayload, CreateWorkshopNoteFailPayload>();

export { createWorkshopNoteActions as default};
